"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableRowCells = void 0;
var react_1 = __importDefault(require("react"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var CheckCircleOutlined_1 = __importDefault(require("@material-ui/icons/CheckCircleOutlined"));
var AutorenewOutlined_1 = __importDefault(require("@material-ui/icons/AutorenewOutlined"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var react_i18next_1 = require("react-i18next");
exports.DataTableRowCells = function (_a) {
    var row = _a.row, columns = _a.columns;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null, row.values
        .filter(function (r, i) { return i < columns.length; })
        .map(function (v, i) {
        return (react_1.default.createElement(TableCell_1.default, { key: v + columns[i].label, align: columns[i].alignment === 'right' ? 'right' : 'left' },
            (columns[i].isStatus || columns[i].isUpdateStatus) && v && v !== 'actions.inProgress' && (react_1.default.createElement(Tooltip_1.default, { title: columns[i].isStatus ? t('actions.completed') : t('updateOverview.ok') },
                react_1.default.createElement(CheckCircleOutlined_1.default, null))),
            (columns[i].isStatus || columns[i].isUpdateStatus) && (!v || v === 'actions.inProgress') && (react_1.default.createElement(Tooltip_1.default, { title: columns[i].isStatus
                    ? t('actions.inProgress')
                    : t('updateOverview.deprecated') },
                react_1.default.createElement(AutorenewOutlined_1.default, null))),
            !columns[i].isStatus && !columns[i].isUpdateStatus && v));
    })));
};
exports.default = exports.DataTableRowCells;
//# sourceMappingURL=DataTableRowCells.js.map